import React, { useEffect, useState } from 'react'
import T from '../i18n/T'
import FavouriteModeBox from './FavouriteModeBox'
import ModeSpeedSettingsBox from './ModeSpeedSettingsBox'
import s from './TravelOptions.less'
import sUserManageFavorites from '../UserAccount/connected/userFavorites/UserManageFavorite.less'
import VehicleSettingsBox from './VehicleSettingsBox'
import { useAction } from '../utils/react-redux'
import { saveTravelOptions } from '../../store/userAccount/userAccount.actions'
import { useTemporaryVisible } from '../genericComponents/useTemporaryVisible'

const TravelOptions = () => {
  const execSaveTravelOptions = useAction(saveTravelOptions)
  const [visible, setVisible] = useTemporaryVisible()
  const [travelOptionsError, setTravelOptionsError] = useState()

  useEffect(() => {
    return async () => {
      const saveTravelOptionsResult = await execSaveTravelOptions()

      if (saveTravelOptionsResult?.error) {
        setVisible(true)
        setTravelOptionsError(saveTravelOptionsResult.error)
      }
    }
  }, [])

  return (
    <>
      {visible && <div className={sUserManageFavorites.errorMessage}>{travelOptionsError}</div>}
      <div className={s.boxWrapper}>
        <h2>
          <T id={'itinerary.options.title.preferred-mode'} />
        </h2>
        <div className={s.boxContent}>
          <FavouriteModeBox />
        </div>
      </div>
      <div className={s.boxWrapper}>
        <h2>
          <T id={'itinerary.options.title.car'} />
        </h2>
        <div className={s.boxContent}>
          <VehicleSettingsBox modeId="car" />
        </div>
      </div>
      <div className={s.boxWrapper}>
        <h2>
          <T id={'itinerary.options.title.motorbike'} />
        </h2>
        <div className={s.boxContent}>
          <VehicleSettingsBox modeId="motorbike" hasOwnSwitcher />
        </div>
      </div>
      <div className={s.boxWrapper}>
        <h2>
          <T id={'itinerary.options.title.walk'} />
        </h2>
        <div className={s.boxContent}>
          <ModeSpeedSettingsBox modeId="walk" />
        </div>
      </div>
      <div className={s.boxWrapper}>
        <h2>
          <T id={'itinerary.options.title.bike'} />
        </h2>
        <div className={s.boxContent}>
          <ModeSpeedSettingsBox modeId="bike" hasOwnSwitcher />
        </div>
      </div>
      <div className={s.boxWrapper}>
        <h2>
          <T id={'itinerary.options.title.trottinette'} />
        </h2>
        <div className={s.boxContent}>
          <ModeSpeedSettingsBox modeId="trottinette" hasOwnSwitcher />
        </div>
      </div>
    </>
  )
}

export default TravelOptions
